import gsap from 'gsap';
import toArray from '../../helpers/toArray';

const tween = (target, delay) => {
  gsap.fromTo(target, {
    opacity: 0,
  }, {
    opacity: 1,
    delay,
    duration: 1.5,
  });
};

export default (element, isIntersecting) => {
  const iframes = toArray(element.querySelectorAll('iframe[src*=vimeo]'));
  const image = element.querySelector('.js-text-imac-image');
  const body = element.querySelector('.js-text-imac-body');

  if (!element.classList.contains('shown-imac')) {
    if (image && isIntersecting) {
      tween(image, 0.75);
    }

    if (body && isIntersecting) {
      tween(body, 0.25);
    }

    element.classList.add('shown-imac');
  }

  if (!iframes.length) {
    return;
  }

  iframes.forEach((iframe) => {
    import(/* webpackChunkName: "vimeo" */ '@vimeo/player').then((module) => {
      const Vimeo = module.default;
      const vimeoPlayer = new Vimeo(iframe);

      vimeoPlayer[isIntersecting ? 'play' : 'pause']()
        .catch(() => {
          // Into the void
        });
    });
  });
};
